import React, { useState, useEffect } from 'react';
import './DynamicText.css';

const DynamicText = ({ staticText, dynamicWords, typingSpeed = 100, deletingSpeed = 50, pauseDuration = 2000 }) => {
  const [displayText, setDisplayText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const currentWord = dynamicWords[wordIndex];
    
    if (isPaused) {
      const pauseTimer = setTimeout(() => {
        setIsPaused(false);
        setIsDeleting(true);
      }, pauseDuration);
      return () => clearTimeout(pauseTimer);
    }

    if (!isDeleting && displayText === currentWord) {
      setIsPaused(true);
      return;
    }

    if (isDeleting && displayText === '') {
      setIsDeleting(false);
      setWordIndex((prev) => (prev + 1) % dynamicWords.length);
      return;
    }

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setDisplayText(currentWord.substring(0, displayText.length + 1));
      } else {
        setDisplayText(displayText.substring(0, displayText.length - 1));
      }
    }, isDeleting ? deletingSpeed : typingSpeed);

    return () => clearTimeout(timeout);
  }, [displayText, wordIndex, isDeleting, isPaused, dynamicWords, typingSpeed, deletingSpeed, pauseDuration]);

  return (
    <div className="dynamic-text-container">
      <span className="static-text">{staticText}</span>
      <span className="dynamic-text">
        {displayText}
        <span className="cursor">|</span>
      </span>
    </div>
  );
};

export default DynamicText;
